import { Stars } from '../../../Reviews'
import { useReviewsCarouselVariants } from '../../../Theme'

import type { ReviewCardProps } from '../../types'

/**
 * ReviewCard - Single customer review card (DUMB / presentational).
 *
 * Reuses the theme-driven Stars component (same look as the PDP reviews) and
 * links the product footer to the reviewed product.
 */
export function ReviewCard({ review }: ReviewCardProps) {
  const {
    reviewCardVariants,
    reviewCardNicknameVariants,
    reviewCardSummaryVariants,
    reviewCardBodyVariants,
    reviewCardDateVariants,
    reviewCardProductImageVariants,
    reviewCardProductNameVariants,
  } = useReviewsCarouselVariants()

  const { nickname, summary, text, formattedDate, rating, product } = review

  return (
    <article className={reviewCardVariants()}>
      <div className="flex items-center justify-between gap-2">
        <span className={reviewCardNicknameVariants()}>{nickname}</span>
        <Stars totalStars={rating} size="sm" />
      </div>

      {summary ? <p className={reviewCardSummaryVariants()}>{summary}</p> : null}
      <p className={reviewCardBodyVariants()}>{text}</p>
      <time className={reviewCardDateVariants()}>{formattedDate}</time>

      <a
        href={product.url}
        className="mt-auto flex items-center gap-2 border-t border-cards-bg pt-1.5 text-text-color no-underline hover:text-text-color hover:no-underline visited:text-text-color active:text-text-color"
      >
        {product.image ? (
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className={reviewCardProductImageVariants()}
          />
        ) : null}
        <span className={reviewCardProductNameVariants()}>{product.name}</span>
      </a>
    </article>
  )
}
